<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人管理</el-breadcrumb-item>
        <el-breadcrumb-item>机器详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
        
        <el-form  id="selectForm" :inline="true" :model="robot" class="demo-form-inline" >
            <div style="width:100%;height:100%;border:1px solid #000020 ">
                <el-row style="margin-top: 10px;">
                    <el-col :span="18" :push="1">
                        <el-form-item label="机器编号:" class="robot">
                            {{robot.robotNo}}
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                         <el-button type="primary"   @click="back()" style="float: right;">返回上一页 </el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"  :push="1">
                        <el-form-item label="机器名称:">
                            {{robot.robotName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1">
                        <el-form-item label="机器类型:" >
                            <span v-if="robot.robotType==='1'">
                                消杀
                            </span>
                            <span v-if="robot.robotType==='2'">
                                安保
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1"> 
                        <el-form-item label="机器状态:" >
                            <span v-if="robot.status==='0'">
                                离线
                            </span>
                            <span v-if="robot.status==='1'" style="color:blue">
                                在线
                            </span>
                            <span v-if="robot.status==='10'" style="color:blue" >
                                升级中
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1">
                        <el-form-item label="机器电量:" >
                                {{robot.eleQuantity}}%
                            </el-form-item>  
                        </el-col>
                </el-row>
                <el-row style=" margin-top: 10px;" :push="1">
                    <el-col :span="6"  :push="1">
                        <el-form-item label="硬件编号:">
                        {{robot.hardwareNo}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1">
                        <el-form-item label="软件版本:" :push="1">
                            {{robot.version}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1">
                        <el-form-item label="开启时间:"  :push="1">
                            {{robot.startTime}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :push="1">
                        <el-form-item label="离线时间:" >
                            {{robot.offlineTime}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4"  :push="1">
                        <el-form-item >
                            <el-button type="primary"  class="el-icon-tickets" @click="jumpLog()">日志下载</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" :push="1">
                        <el-form-item >
                            <el-button type="info" class="el-icon-tickets" @click="jumpWorkLog()">工作日志</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" :push="1">
                        <el-form-item >
                            <el-button type="danger" class="el-icon-tickets" @click="repairLog()">维修记录</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4"  :push="1">
                        <el-form-item >
                            <el-button type="primary" class="el-icon-location-information" @click="taskDialog()">地图列表</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4"  :push="1">
                        <el-form-item >
                            <el-button type="primary" class="el-icon-download" @click="remoteUpdate()">远程更新</el-button>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="4"  :push="1">
                        <el-form-item >
                            <el-button type="primary" class="el-icon-location-information" @click="remoteReboot()">远程重启</el-button>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </div>
        </el-form>
    </el-card >
  </div>
</template>

<script>
export default {
  name: 'missionPlanning',
  data(){
      return {
        robot:{
           
        }
        
      }
  },
  
   //生命周期函数
  created(){
    this.getRobot()
  },


  methods:{
        getRobot(){
            var id=this.$route.query.id;
            this.$http.get('robot/getRobotById',{params :{ id :  id }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.robot=response.data.result
                      
                    }else{
                        return this.$message.error(res.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        //远程更新
        remoteUpdate(){
            var id=this.$route.query.id;
            this.$http.get('robot/remoteUpdate',{params :{ id :  id }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.robot=response.data.result;
                        this.$message.success("命令下发成功,稍后请刷新页面！");
                        // setTimeout(function() {
                        //     window.location.reload();
                        // },5000)
                        return
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        //远程重启
        remoteReboot(){
            var id=this.$route.query.id;
            this.$http.get('robot/remoteReboot',{params :{ id :  id }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.robot=response.data.result
                    }else{
                        return this.$message.error(res.message);
                    }
                }).catch(failResponse => {
                
            })
        },
         //跳转机器人日志页面
        jumpLog(){
            // this.robot.robotNo=this.$route.query.robotNo;
            // this.robot.status=this.$route.query.status;
            this.$router.replace({path: '/robotlog?robotNo='+this.robot.robotNo+"&status="+this.robot.status+'&pageFlag='+"2"+'&id='+this.robot.id})
        },
        jumpWorkLog(){
            //this.robot.robotNo=this.$route.query.robotNo;
            this.$router.replace({path: '/workWarn?robotNo='+this.robot.robotNo+'&pageFlag='+"3"+'&id='+this.robot.id})
        },
        repairLog(){ 
            //this.robot.robotNo=this.$route.query.robotNo;
            this.$router.replace({path: '/repair?robotNo='+this.robot.robotNo+'&pageFlag='+"2"+'&id='+this.robot.id})
        },
         //任务编辑弹框
        taskDialog(){
           // this.robot.robotNo=this.$route.query.robotNo;
            this.$router.replace({path: '/taskMap?robotNo='+this.robot.robotNo+'&id='+this.robot.id})
        },
        back(){
            this.$router.replace({path: '/missionPlanning'})
        }
  }
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.elll-input {
    width: 150px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.m-l-20 {
  margin-left: 0px !important;
}

.el-row {
    margin-bottom: 10px;
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}

.dialog1 {
    font-weight: bold;
    align-content: center;
    margin:auto;
}
.box-card {
    // background:url("../../assets/3.png") no-repeat;
    // background-position: center;
    // height: 100%;
    // width: 100%;
    // background-size: "100% 100%";
    // //background-color:hsl(0, 25%, 24%);
    // position: fixed;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
}

/deep/  .el-form-item__label {
  font-size: 18px;
  font-weight: 800;
}

 /deep/ .el-form-item__content {
    font-size: 16px;
    font-weight: 800;
  }

</style>


// WEBPACK FOOTER //
// src/components/robot/RobotManage.vue